export const ViewTypeEnum = {
  InRecipes: 0,
  InCycleMenu: 1,
  All: 2,
};

export const ViewTypeOptions = [
  {
    value: ViewTypeEnum.InRecipes,
    text: 'Associated to Recipes',
  },
  {
    value: ViewTypeEnum.InCycleMenu,
    text: 'Associated to Cycle Menu',
  },
  { value: ViewTypeEnum.All, text: 'All' },
];



// WEBPACK FOOTER //
// ./src/pages/DiscontinuedIngredients/helpers/constants.js